import type { FieldValues } from "react-hook-form";
import { useI18nContext } from "@hopper-b2b/i18n";
import {
  emailRegex as defaultEmailRegex,
  phoneRegex as defaultPhoneRegex,
} from "@hopper-b2b/utilities";

/**
 * Don't access checkout state here, as this shared with onboarding page before checkout flow
 */
export const useContactInformationFormFields = () => {
  const {
    t,
    brand: { preferredAreaCode },
  } = useI18nContext();

  const formFields: Partial<Record<string, FieldValues>> = {
    countryCode: {
      required: t("apac.contactInfo.errors.phoneRequired"),
    },
    phoneNumber: {
      required: t("apac.contactInfo.errors.phoneRequired"),
      minLength: {
        value: 8,
        message: t("contactInfoPhoneError"),
      },
      pattern: {
        value: defaultPhoneRegex,
        message: t("contactInfoPhoneError"),
      },
    },
    email: {
      required: t("apac.contactInfo.errors.emailRequired"),
      pattern: {
        value: defaultEmailRegex,
        message: t("contactInfoEmailError"),
      },
    },
  };

  return {
    formFields,
    contactInfoDefaultValues: {
      phoneNumber: "",
      email: "",
      countryCode: preferredAreaCode,
    },
  };
};
